"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var core_1 = require('@angular/core');
var http_1 = require('@angular/http');
var common_1 = require('@angular/common');
var forms_1 = require('@angular/forms');
var angular2_perfect_scrollbar_1 = require('angular2-perfect-scrollbar');
var font_picker_service_1 = require('./font-picker.service');
var font_picker_component_1 = require('./font-picker.component');
var font_picker_directive_1 = require('./font-picker.directive');
var interfaces_1 = require('./interfaces');
var pipes_1 = require('./pipes');
exports.FONT_PICKER_GUARD = new core_1.OpaqueToken('FONT_PICKER_GUARD');
exports.FONT_PICKER_CONFIG = new core_1.OpaqueToken('FONT_PICKER_CONFIG');
var FontPickerModule = (function () {
    function FontPickerModule(guard) {
    }
    FontPickerModule.forRoot = function (config) {
        return {
            ngModule: FontPickerModule,
            providers: [
                font_picker_service_1.FontPickerService,
                {
                    provide: exports.FONT_PICKER_GUARD,
                    useFactory: provideForRootGuard,
                    deps: [
                        [
                            interfaces_1.FontPickerConfig,
                            new core_1.Optional(),
                            new core_1.SkipSelf()
                        ]
                    ]
                },
                {
                    provide: exports.FONT_PICKER_CONFIG,
                    useValue: config ? config : {}
                },
                {
                    provide: interfaces_1.FontPickerConfig,
                    useFactory: provideDefaultConfig,
                    deps: [
                        exports.FONT_PICKER_CONFIG
                    ]
                }
            ]
        };
    };
    FontPickerModule.forChild = function () {
        return {
            ngModule: FontPickerModule
        };
    };
    FontPickerModule = __decorate([
        core_1.NgModule({
            declarations: [font_picker_component_1.FontPickerComponent, font_picker_directive_1.FontPickerDirective, pipes_1.FontSizePipe, pipes_1.FontStylesPipe, pipes_1.StatefulSlicePipe],
            imports: [common_1.CommonModule, http_1.HttpModule, forms_1.FormsModule, forms_1.ReactiveFormsModule, angular2_perfect_scrollbar_1.PerfectScrollbarModule],
            exports: [forms_1.FormsModule, forms_1.ReactiveFormsModule, font_picker_directive_1.FontPickerDirective, pipes_1.FontSizePipe, pipes_1.FontStylesPipe, pipes_1.StatefulSlicePipe],
            entryComponents: [font_picker_component_1.FontPickerComponent]
        }),
        __param(0, core_1.Optional()),
        __param(0, core_1.Inject(exports.FONT_PICKER_GUARD)), 
        __metadata('design:paramtypes', [Object])
    ], FontPickerModule);
    return FontPickerModule;
}());
exports.FontPickerModule = FontPickerModule;
function provideForRootGuard(config) {
    if (config) {
        throw new Error("\n      Application called FontPickerModule.forRoot() twice.\n      For submodules use FontPickerModule.forChild() instead.\n    ");
    }
    return 'guarded';
}
exports.provideForRootGuard = provideForRootGuard;
function provideDefaultConfig(config) {
    return new interfaces_1.FontPickerConfig(config);
}
exports.provideDefaultConfig = provideDefaultConfig;



//////////////////
// WEBPACK FOOTER
// ./src/lib/font-picker.module.ts
// module id = 35
// module chunks = 0 1